function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["signals", "hasLegend", "index"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { parseSelector } from 'vega-event-selector';
import { identity, isArray, stringValue } from 'vega-util';
import { MODIFY, STORE, unitName, VL_SELECTION_RESOLVE, TUPLE, selectionCompilers, isTimerSelection } from '.';
import { dateTimeToExpr, isDateTime, dateTimeToTimestamp } from '../../datetime';
import { hasContinuousDomain } from '../../scale';
import { SELECTION_ID } from '../../selection';
import { keys, replacePathInField, stringify, vals } from '../../util';
import { isUnitModel } from '../model';
import { parseSelectionExtent } from './parse';
import { CURR } from './point';
import { DataSourceType } from '../../data';
export function assembleProjection(proj) {
  var signals = proj.signals,
    hasLegend = proj.hasLegend,
    index = proj.index,
    rest = _objectWithoutProperties(proj, _excluded);
  rest.field = replacePathInField(rest.field);
  return rest;
}
export function assembleInit(init) {
  var isExpr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  if (isArray(init)) {
    var assembled = init.map(function (v) {
      return assembleInit(v, isExpr, wrap);
    });
    return isExpr ? "[".concat(assembled.join(', '), "]") : assembled;
  } else if (isDateTime(init)) {
    if (isExpr) {
      return wrap(dateTimeToExpr(init));
    } else {
      return wrap(dateTimeToTimestamp(init));
    }
  }
  return isExpr ? wrap(stringify(init)) : init;
}
export function assembleUnitSelectionSignals(model, signals) {
  var _model$component$sele;
  var _iterator = _createForOfIteratorHelper(vals((_model$component$sele = model.component.selection) !== null && _model$component$sele !== void 0 ? _model$component$sele : {})),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var selCmpt = _step.value;
      var name = selCmpt.name;
      var modifyExpr = "".concat(name).concat(TUPLE, ", ").concat(selCmpt.resolve === 'global' ? 'true' : "{unit: ".concat(unitName(model), "}"));
      var _iterator2 = _createForOfIteratorHelper(selectionCompilers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          if (!c.defined(selCmpt)) continue;
          if (c.signals) signals = c.signals(model, selCmpt, signals);
          if (c.modifyExpr) modifyExpr = c.modifyExpr(model, selCmpt, modifyExpr);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      signals.push({
        name: name + MODIFY,
        on: [{
          events: {
            signal: selCmpt.name + TUPLE
          },
          update: "modify(".concat(stringValue(selCmpt.name + STORE), ", ").concat(modifyExpr, ")")
        }]
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cleanupEmptyOnArray(signals);
}
export function assembleFacetSignals(model, signals) {
  if (model.component.selection && keys(model.component.selection).length) {
    var name = stringValue(model.getName('cell'));
    signals.unshift({
      name: 'facet',
      value: {},
      on: [{
        events: parseSelector('pointermove', 'scope'),
        update: "isTuple(facet) ? facet : group(".concat(name, ").datum")
      }]
    });
  }
  return cleanupEmptyOnArray(signals);
}
export function assembleTopLevelSignals(model, signals) {
  var _model$component$sele2;
  var hasSelections = false;
  var _iterator3 = _createForOfIteratorHelper(vals((_model$component$sele2 = model.component.selection) !== null && _model$component$sele2 !== void 0 ? _model$component$sele2 : {})),
    _step3;
  try {
    var _loop = function _loop() {
      var selCmpt = _step3.value;
      var name = selCmpt.name;
      var store = stringValue(name + STORE);
      var hasSg = signals.filter(function (s) {
        return s.name === name;
      });
      if (hasSg.length === 0) {
        var resolve = selCmpt.resolve === 'global' ? 'union' : selCmpt.resolve;
        var isPoint = selCmpt.type === 'point' ? ', true, true)' : ')';
        signals.push({
          name: selCmpt.name,
          update: "".concat(VL_SELECTION_RESOLVE, "(").concat(store, ", ").concat(stringValue(resolve)).concat(isPoint)
        });
      }
      hasSelections = true;
      var _iterator4 = _createForOfIteratorHelper(selectionCompilers),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var c = _step4.value;
          if (c.defined(selCmpt) && c.topLevelSignals) {
            signals = c.topLevelSignals(model, selCmpt, signals);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (hasSelections) {
    var hasUnit = signals.filter(function (s) {
      return s.name === 'unit';
    });
    if (hasUnit.length === 0) {
      signals.unshift({
        name: 'unit',
        value: {},
        on: [{
          events: 'pointermove',
          update: 'isTuple(group()) ? group() : unit'
        }]
      });
    }
  }
  return cleanupEmptyOnArray(signals);
}
export function assembleUnitSelectionData(model, data) {
  var _model$component$sele3;
  var selectionData = [];
  var animationData = [];
  var unit = unitName(model, {
    escape: false
  });
  var _iterator5 = _createForOfIteratorHelper(vals((_model$component$sele3 = model.component.selection) !== null && _model$component$sele3 !== void 0 ? _model$component$sele3 : {})),
    _step5;
  try {
    var _loop2 = function _loop2() {
      var selCmpt = _step5.value;
      var store = {
        name: selCmpt.name + STORE
      };
      if (selCmpt.project.hasSelectionId) {
        store.transform = [{
          type: 'collect',
          sort: {
            field: SELECTION_ID
          }
        }];
      }
      if (selCmpt.init) {
        var fields = selCmpt.project.items.map(assembleProjection);
        store.values = selCmpt.project.hasSelectionId ? selCmpt.init.map(function (i) {
          return _defineProperty({
            unit: unit
          }, SELECTION_ID, assembleInit(i, false)[0]);
        }) : selCmpt.init.map(function (i) {
          return {
            unit: unit,
            fields: fields,
            values: assembleInit(i, false)
          };
        });
      }
      var contains = [].concat(selectionData, _toConsumableArray(data)).filter(function (d) {
        return d.name === selCmpt.name + STORE;
      });
      if (!contains.length) {
        selectionData.push(store);
      }
      if (isTimerSelection(selCmpt) && data.length) {
        // TODO(jzong): eventually uncomment this stuff when we want to support multi-view
        // const sourceName =
        //   model.parent && model.parent.type !== 'unit' // facet, layer, or concat
        //     ? model.parent.lookupDataSource(model.parent.getDataName(DataSourceType.Main))
        //     : model.lookupDataSource(model.getDataName(DataSourceType.Main));
        var sourceName = model.lookupDataSource(model.getDataName(DataSourceType.Main));
        var sourceData = data.find(function (d) {
          return d.name === sourceName;
        });
        // find the filter transform for the current selection
        var sourceDataFilter = sourceData.transform.find(function (t) {
          return t.type === 'filter' && t.expr.includes('vlSelectionTest');
        });
        if (sourceDataFilter) {
          // remove it from the original dataset
          sourceData.transform = sourceData.transform.filter(function (t) {
            return t !== sourceDataFilter;
          });
          // create dataset to hold current animation frame
          var currentFrame = {
            name: sourceData.name + CURR,
            source: sourceData.name,
            transform: [sourceDataFilter] // add the selection filter to the animation dataset
          };
          animationData.push(currentFrame);
        }
      }
    };
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return selectionData.concat(data, animationData);
}
export function assembleUnitSelectionMarks(model, marks) {
  var _model$component$sele4;
  var _iterator6 = _createForOfIteratorHelper(vals((_model$component$sele4 = model.component.selection) !== null && _model$component$sele4 !== void 0 ? _model$component$sele4 : {})),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var selCmpt = _step6.value;
      var _iterator7 = _createForOfIteratorHelper(selectionCompilers),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var c = _step7.value;
          if (c.defined(selCmpt) && c.marks) {
            marks = c.marks(model, selCmpt, marks);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return marks;
}
export function assembleLayerSelectionMarks(model, marks) {
  var _iterator8 = _createForOfIteratorHelper(model.children),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var child = _step8.value;
      if (isUnitModel(child)) {
        marks = assembleUnitSelectionMarks(child, marks);
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return marks;
}
export function assembleSelectionScaleDomain(model, extent, scaleCmpt, domain) {
  var parsedExtent = parseSelectionExtent(model, extent.param, extent);
  return {
    signal: hasContinuousDomain(scaleCmpt.get('type')) && isArray(domain) && domain[0] > domain[1] ? "isValid(".concat(parsedExtent, ") && reverse(").concat(parsedExtent, ")") : parsedExtent
  };
}
function cleanupEmptyOnArray(signals) {
  return signals.map(function (s) {
    if (s.on && !s.on.length) delete s.on;
    return s;
  });
}